/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIContactAutocompleteSuggestion
 */
export interface APIContactAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APIContactAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAutocompleteSuggestion
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAutocompleteSuggestion
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAutocompleteSuggestion
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAutocompleteSuggestion
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAutocompleteSuggestion
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof APIContactAutocompleteSuggestion
     */
    mobile?: string;
}

/**
 * Check if a given object implements the APIContactAutocompleteSuggestion interface.
 */
export function instanceOfAPIContactAutocompleteSuggestion(value: object): value is APIContactAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function APIContactAutocompleteSuggestionFromJSON(json: any): APIContactAutocompleteSuggestion {
    return APIContactAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APIContactAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIContactAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'],
        'fullName': json['full_name'] == null ? undefined : json['full_name'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
    };
}

export function APIContactAutocompleteSuggestionToJSON(value?: APIContactAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'full_name': value['fullName'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'phone': value['phone'],
        'mobile': value['mobile'],
    };
}

